__turbopack_context__.v({
  "card": "TrustedBy-module__3ag6Fa__card",
  "container": "TrustedBy-module__3ag6Fa__container",
  "grid": "TrustedBy-module__3ag6Fa__grid",
  "iconWrapper": "TrustedBy-module__3ag6Fa__iconWrapper",
  "name": "TrustedBy-module__3ag6Fa__name",
  "title": "TrustedBy-module__3ag6Fa__title",
  "trusted": "TrustedBy-module__3ag6Fa__trusted",
});
